import React, { useEffect, useRef, useState } from 'react'
import Chart from 'react-apexcharts';
import MonthDD from '../../../../utils/MonthDD';
import AmountFormatter from '../../../../utils/AmountFormatter';
import { createPortal } from 'react-dom';
import useSidebarSubMainTab from '../../../shared/HandleOpenSidebarSubTab/useSidebarSubMainTab';
import CustomUseRef from '../../../shared/DropDown/CustomUseRef';

const ClusteredStackedColumnChart = ({ data, FinancialFilterDateType }) => {

  // console.log(data, FinancialFilterDateType, 'FinancialFilterDateType');

  const [hoveredPoint, setHoveredPoint] = useState(null);
  const [isHovered, setIsHovered] = useState(true);
  const hoverTimer = useRef(null); // Ref to hold the timer ID
  let Data = JSON.parse(JSON.stringify(data));
  let currMonth = new Date().getMonth();
  let currYear = new Date().getFullYear();
  let months = [
    ...MonthDD.slice(currMonth + 1, 12).map(month => `${month} ${currYear - 1}`),
    ...MonthDD.slice(0, currMonth + 1).map(month => `${month} ${currYear}`)
  ].reverse();
  Data = Data
    ?.filter(item =>
      !(item.name === 'Patient Payment' &&
        item.group === 'Patient Payment' &&
        ["Adult Day Care", "Homecare Agency"].includes(item.PracticeType))
    );
  // ['#3379ff', 'var(--primary)', '#FFB013', '#8DFF97', ' #35793A', '#FF2C2C', '#9E75F6', '#D50C12', '#f2e88f']
  const colorMaphomecare = {
    'Charges': '#3379ff',
    'Billed': 'var(--primary)',
    'Not Billed': '#FFB013',
    'Insurance Payment': '#8DFF97',
    'Patient Payment': '#35793A',
    'Denied': '#FF2C2C',
    'Adjustments': '#9E75F6',
    'WriteOff': '#D50C12',
    'Balance': '#f2e88f',
  };

  const dynamicColors = Data.map(item => colorMaphomecare[item.name] || '#ccc');

  // console.log(Data,'DataDataDataData');
  

  // Data = Data?.map((item) => {
  //   if (["Patient Payment", "Insurance Payment"].includes(item?.group)) {
  //     item.group = "Payment"
  //   }
  //   return item;
  // }).filter(item => !(item.name === 'Patient Payment' && item.group === 'Payment' && ["Adult Day Care", "Homecare Agency"].includes(item.PracticeType)));

  let isNotHomeCareCheck = Data?.filter(item => !["Adult Day Care", "Homecare Agency"].includes(item.PracticeType))?.length > 0;
  // console.log("isNotHomeCareCheck", isNotHomeCareCheck,)
  const initialOptions = {
    series: Data || [],
    chart: {
      type: 'bar',
      height: 380,
      stacked: true,
      events: {
        dataPointMouseEnter: function (event, chartContext, config) {
          hoverTimer.current = setTimeout(() => {
            setHoveredPoint({
              position: { X: event.clientX, Y: event.clientY },
              seriesIndex: config.seriesIndex,
              dataPointIndex: config.dataPointIndex,
              w: chartContext.w,
            });
            setIsHovered(true);
          }, 50);
        },
        dataPointMouseLeave: function () {
          clearTimeout(hoverTimer.current); // Cancel the pending timeout
        },
      },
    },
    stroke: {
      colors: ["transparent"],
      width: 1
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '50%',
      },
    },
    xaxis: {
      categories: months,
      labels: {
        style: {
          fontSize: 12,
          fontFamily: 'Poppins',
          fontWeight: '400',
          colors: '#434343',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: 12,
          fontFamily: 'Poppins',
          fontWeight: '400',
          colors: '#434343',
        },
        formatter: (val) => {
          return `$${String(val).length < 4 ? val : String(val).length < 7 ? val / 1000 + 'K' : String(val).length >= 7 ? val / 1000000 + 'M' : val}`;
        },
      },
    },
    fill: {
      opacity: 1,
    },
    colors: dynamicColors,
    // colors: isNotHomeCareCheck ?
    //   //'var(--BlueColor)' old balance color
    //   ['#3379ff', 'var(--primary)', '#FFB013', '#07C919', ' #5AB461', '#FF2C2C', '#9E75F6', '#D50C12', '#f2e88f'] :
    //   ['#3379ff', 'var(--primary)', '#FFB013', '#5AB461', '#FF2C2C', '#9E75F6', '#D50C12', '#f2e88f'],
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      fontSize: 12,
      fontFamily: 'Poppins',
      fontWeight: '500',
      markers: {
        height: 10,
        width: 10,
      }
    },
    tooltip: {
      enabled: false, // Disable the default tooltip
    },
    grid: {
      border: '0.25px solid #959595',
    },
  };

  const [state, setState] = useState(initialOptions);

  return (
    <>
      <Chart
        options={state}
        series={state.series}
        type={state.chart.type}
        height={state.chart.height}
      />
      {console.log("hoveredPoint", hoveredPoint)}
      {hoveredPoint && isHovered && hoveredPoint.seriesIndex !== -1 && (
        createPortal(
          <CustomTooltip
            position={hoveredPoint.position}
            series={state.series}
            seriesIndex={hoveredPoint.seriesIndex}
            dataPointIndex={hoveredPoint.dataPointIndex}
            w={hoveredPoint.w}
            setHoveredPoint={setHoveredPoint}
            isHovered={isHovered}
            setIsHovered={setIsHovered}
            FinancialFilterDateType={FinancialFilterDateType}
            months={months}
          />,
          document.getElementById('root') // Render to the root
        )
      )}
    </>
  );
};

export default ClusteredStackedColumnChart;
const CustomTooltip = ({ position, series, seriesIndex, dataPointIndex, w, setHoveredPoint, isHovered, setIsHovered, FinancialFilterDateType, months }) => {
  const openSidebarSubMainTab = useSidebarSubMainTab();
  const [isOverflowedY, setIsOverflowedY] = useState(false);
  const [isOverflowedX, setIsOverflowedX] = useState(false);

  const checkTooltipOverflow = () => {
    const tooltip = document.getElementById('tooltip');
    const rect = tooltip.getBoundingClientRect();
    console.log(rect)
    setIsOverflowedY(rect.bottom > window.innerHeight);
    setIsOverflowedX(rect.right > window.innerWidth);

  };

  useEffect(() => {
    checkTooltipOverflow();
    window.addEventListener('resize', checkTooltipOverflow);
    return () => window.removeEventListener('resize', checkTooltipOverflow);
  }, []);
  console.log("position", position)
  const seriesData = w.config.series.map((item, index) => {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    let amount = item.data?.[dataPointIndex]
      ? formatter.format(item.data[dataPointIndex])
      : formatter.format(0);

    if (item.name === 'Charges') {
      return (
        <div
          key={index}
          className="px-10 pt-2 pb-2px br-bottom-1 br-light d-flex justify-content-between align-items-center"
        >
          <p className='xsm_heading'>{w.globals.labels[dataPointIndex]}</p>
          <p className='xsm_heading'>{amount}</p>
        </div>
      );
    } else {

      const handleNavigate = (name) => {
        console.log(months[dataPointIndex],'name');
        
        const paths = {
          'Denied': `Account Receivables-7222-{"DateType":"${FinancialFilterDateType} ${months[dataPointIndex]}"}`,
          // 'Billed': `Reports-413-{"DateType":"${FinancialFilterDateType} ${months[dataPointIndex]}"}`,
          'Billed': `Reports-413-${JSON.stringify({
            DateType: `${FinancialFilterDateType} ${months[dataPointIndex]}`,
            Submitted: "1"
          })}`,

          'Not Billed': `Claims-71-{"DateType":"${FinancialFilterDateType} ${months[dataPointIndex]}"}`,
          'Patient Payment': `Reports-434-{"DateType":"${FinancialFilterDateType} ${months[dataPointIndex]}"}`,
          'Insurance Payment': `Reports-413-{"DateType":"${FinancialFilterDateType} ${months[dataPointIndex]}"}`,
          'Adjustments': `Reports-413-{"DateType":"${FinancialFilterDateType} ${months[dataPointIndex]}"}`,
          'Balance': `Reports-432-{"DateType":"${FinancialFilterDateType} ${months[dataPointIndex]}"}`,
          'WriteOff': `Reports-4310-{"DateType":"${FinancialFilterDateType} ${months[dataPointIndex]}"}`,
        };
        if (paths[name]) {
          openSidebarSubMainTab(paths[name]);
        }
        handleClose();
      };
      return (
        <div
          key={index}
          className='d-flex justify-content-between mt-1 ar-financial-tooltip-popup px-10'
          style={{ width: '200px' }}
        >
          <p className='xsm_text'>
            <span
              style={{
                display: 'inline-block',
                backgroundColor: w.globals.colors[index],
                width: '6px',
                height: '6px',
                borderRadius: '3px',
                marginRight: '5px',
              }}
            ></span>
            {item.name}
          </p>
          <p className='xsm_text ammount-text cursor-pointer' onClick={() => { handleNavigate(item.name); }}>{amount}</p>
        </div>
      );
    }
  });
  console.log("isHovered", isHovered)
  const handleClose = () => {
    setIsHovered(false);
    setHoveredPoint(null);
  }
  return (
    // <CustomUseRef onClose={handleClose} IsActivePtPayments={false}>
    <div
      id="tooltip" className={`apexcharts-tooltip-title ar-apexcharts-tooltip-title p-0 Financial-Summary mb-0 ${isOverflowedY ? 'flip' : ''} ${isOverflowedX ? 'flipX' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => { handleClose(); }}
      style={{
        display: isHovered ? 'block' : 'none', position: 'absolute', // Absolute positioning
        top: `${position.Y - 44}px`,
        left: `${position.X - 15}px`,
        zIndex: "100",
        transition: ".15s ease all",
        opacity: 0,
      }}
    >
      <div className='content'>{seriesData}</div>
    </div>

  );
};